/**
 * Popup to configure and request to server .
 */

Greenmile.RouteDetail = Greenmile.RouteDetail || {};
Greenmile.RouteDetail.PopupInfoToReprocess = function (routeId, marker, autoArriveConfiguration) {

    this.rootEl = null;

    var renderErrorMessage = function (message) {
        var monetMessage = new Monet.Form.Messages.InlineMessage();
        monetMessage.setMessage(message);
        monetMessage.setInfoType("error");
        monetMessage.setScope('#routeMapContainer_' + routeId);
        monetMessage.triggerMessage();

        var messageContainer = this.rootEl.querySelector('.alert');
        messageContainer.style.display = 'block';
    }.bind(this);

    var sendDataToService = function (context) {

        return function (data) {

            var loading = context.rootEl.querySelector('img');
            var form = context.rootEl.querySelector('.MonetUIFormSectionColumn');

            var messageContainer = context.rootEl.querySelector('.alert');
            if(messageContainer) {
                messageContainer.style.display = 'none';    
            }
            
            var ajax = new Monet.Ajax();
            ajax.url = 'AutoArriveServiceRouter/Forward?criteria={"filters":["*","organization.*","stops.*","stops.location.key","stops.location.description","stops.cancelCode.*", "stops.stopType.type"]}';
            ajax.method = 'post';
            ajax.data = data;
            ajax.success = function (data) {
                data = data || {};
                marker.closePopup();
                Greenmile.Map.Utility.removeLayerByKind(Monet.Session.RouteDetail.screensList[routeId].map, ['STOP_SUGGESTIONS']);
                new Greenmile.RouteDetail.PopupConfirmReprocess(routeId, data, autoArriveConfiguration).render();
            };
            ajax.error = function (xhr) {
                if (xhr.status === 412) {
                    var error = JSON.parse(xhr.responseText);
                    renderErrorMessage(error);
                } else {
                    Monet.Configurations.errorNotification(null, xhr);
                }
                loading.style.display = 'none';
                form.style.display = 'block';
            };
            loading.style.display = 'block';
            form.style.display = 'none';
            ajax.send();

        };
    }(this);

    this.formToReprocess = function () {

        var form;
        var formRendered;
        var dateRoute;
        var interval;
        var thatRoute;
        var labelHeader;
        var btnReprocess;
        var btnCancel;
        var sectionForm;
        var loading;
        var yesterday = Monet.Format.Date.getTodayISOString({ daysOffset: -1 });
        var today = Monet.Format.Date.getTodayISOString();
        var fieldsList = {
            sections: [{
                key: 'infoToReprocessAutoArrive',
                sectionFields: [{
                    field: {
                        name: 'info',
                        type: 'RADIO_GROUP',
                        fieldDomains: [{
                            description: 'RouteDetail.reprocessAutoArrive.thatRoute',
                            id: 'thatRoute',
                            value: 1
                        }, {
                            value: 2,
                            description: 'RouteDetail.reprocessAutoArrive.interval',
                            id: 'interval'
                        }]
                    },
                    sectionColumn: 1
                }, {
                    field: {
                        id: 'timeToArrive',
                        name: 'timeToArrive',
                        label: "RouteDetail.reprocessAutoArrive.timeToArriveSeconds",
                        mandatory: 'true',
                        type: 'INTEGER',
                        defaultValue: autoArriveConfiguration.numberSecondsToGuessArrival || ""
                    },
                    sectionColumn: 1
                }]
            }]
        };

        var customValidateDate = function () {

            var errors = [];
            if (dateRoute.inputIni.value && dateRoute.inputFin.value) {

                var dateBegin = Monet.Format.Date.parseLocale(dateRoute.inputIni.value).getTime();
                var dateEnd = Monet.Format.Date.parseLocale(dateRoute.inputFin.value).getTime();

                if (dateBegin > dateEnd) {
                    errors = [{
                        name: dateRoute.inputIni.name,
                        label: dateRoute.inputIni.label,
                        message: Monet.I18n.getResourcesByKey('RouteDetail.ReprocessAutoArrive.dateInitialIsGreaterThanDateEnd')
                    }];
                }

            } else {
                errors = [{
                    name: null,
                    label: null,
                    message: Monet.I18n.getResourcesByKey('RouteDetail.ReprocessAutoArrive.intervalIsRequired')
                }];
            }

            if (errors.length) {
                dateRoute.rootEl.className += ' control-group error';
            } else {
                dateRoute.rootEl.className = dateRoute.rootEl.className.replace('control-group error', '');
            }

            return errors;

        };

        form = new Monet.Builder.Form.Base(fieldsList, 'PopupReprocessAutoArrive');
        btnReprocess = new Monet.UI.Fields.Button();
        btnCancel = new Monet.UI.Fields.Button();

        loading = document.createElement('img');
        loading.setAttribute('class', 'loading');
        loading.src = require("static/images/general/loading_blue.svg");
        loading.style.display = 'none';

        btnReprocess.setInputId('reprocess');
        btnReprocess.setValue(Monet.I18n.getResourcesByKey('RouteDetail.reprocessAutoArrive.btnSend'));
        btnReprocess.addEventClickListener(function () {

            var validate = form.validate();
            var values = form.getValues();
            var stop = Monet.Session.RouteDetail.screensList[routeId].editingStop.stop;
            var sendInterval = values.info === "2";
            var radius = stop.location.deliveryRadius || autoArriveConfiguration.defaultLocationRadius;

            if (sendInterval) {

                var customValidate = customValidateDate();
                if (customValidate.length) {
                    validate.status = false;
                    validate.errorMessages = validate.errorMessages.concat(customValidate);
                }

            }

            if (validate.status) {

                var data = {
                    timeOutInSeconds: 40,
                    position: {
                        latitude: marker._latlng.lat,
                        longitude: marker._latlng.lng
                    }
                };

                data.stopId = stop.id;

                if (sendInterval) {

                    var valuesDateTime = dateRoute.getValue();
                    data.from = valuesDateTime.ini;
                    data.to = valuesDateTime.fin;

                }

                data.secondsToArrive = (values.timeToArrive);

                if (radius) {
                    data.radius = radius;
                }

                sendDataToService(data);

            } else {
                renderErrorMessage(validate);
            }

        });

        btnCancel.setInputId('cancelReprocess');
        btnCancel.setValue(Monet.I18n.getResourcesByKey('default.button.cancel'));
        btnCancel.addEventClickListener(function () {
            Greenmile.Map.Utility.removeLayerByKind(Monet.Session.RouteDetail.screensList[routeId].map, ['STOP_SUGGESTIONS']);
            App.Views.RouteDetails.removeGeocodeSuggest(routeId);
            Monet.Session.RouteDetail.screensList[routeId].editingStop = null;
            Monet.Session.RouteDetail.screensList[routeId].isUpdateAutomatic = true;
            marker._popup._close();
        });

        dateRoute = new Monet.UI.Fields.DateRange();
        dateRoute.render().className = 'intervalInputContainer';
        dateRoute.validate = function () {
            return customValidateDate();
        };
        dateRoute.setValue({
            ini: yesterday,
            fin: today
        });

        formRendered = form.renderBaseForm().allContent;

        thatRoute = form.fields.info.getRadioButtons()[0];
        thatRoute.input.addEventListener('change', function () {
            dateRoute.disable();
        });
        dateRoute.disable();

        interval = form.fields.info.getRadioButtons()[1];
        interval.input.checked = false;
        interval.input.addEventListener('change', function () {
            dateRoute.enable();
        });
        interval.input.parentNode.appendChild(dateRoute.rootEl);

        labelHeader = document.createElement('label');
        labelHeader.innerHTML = Monet.I18n.getResourcesByKey('RouteDetail.InfoToReprocessAutoArrive.description');

        sectionForm = formRendered.querySelector('.MonetUIFormSectionColumn');
        sectionForm.parentNode.insertBefore(loading, sectionForm);
        sectionForm.insertBefore(labelHeader, sectionForm.firstChild);
        sectionForm.appendChild(btnReprocess.render());
        sectionForm.appendChild(btnCancel.render());

        return formRendered;
    };

    this.render = function () {
        this.rootEl = this.formToReprocess();
        return this.rootEl;
    };

};
